import { Settings as SettingsIcon } from 'lucide-react'
import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import { useAuth } from '@/store/auth'

import BillingTab from './BillingTab'
import CentersTab from './CentersTab'
import DocumentsTab from './DocumentsTab'
import IntegrationsTab from './IntegrationsTab'
import MyAccountTab from './MyAccountTab'
import PricingTab from './PricingTab'
import RolesTab from './RolesTab'
import RewardsTab from './RewardsTab'
import SubscriptionTab from './SubscriptionTab'
import SystemTab from './SystemTab'
import UsersTab from './UsersTab'
import WidgetTab from './WidgetTab'

export default function SettingsPage() {
  const { t } = useTranslation()
  const user = useAuth((s) => s.user)
  const isAdmin = Boolean(user?.can_administrate)

  const tabs = [
    { to: 'account', label: t('settings.myAccount') },
    ...(isAdmin
      ? [
          { to: 'system', label: t('settings.system') },
          { to: 'pricing', label: t('settings.pricing') },
          { to: 'centers', label: t('centers.title') },
          { to: 'rewards', label: t('settings.rewards') },
          { to: 'widget', label: t('settings.widget') },
          { to: 'integrations', label: t('settings.integrations') },
          { to: 'users', label: t('settings.users') },
          { to: 'roles', label: t('roles.tab') },
          { to: 'billing', label: t('settings.billingTitle') },
          { to: 'subscription', label: t('settings.subscription') },
          { to: 'documents', label: t('settings.documents') },
        ]
      : []),
  ]

  // Menu ako v Pomocníkovi - obsah vľavo (na mobile nad), sekcia vpravo.
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-start">
      <aside className="card shrink-0 p-3 lg:sticky lg:top-4 lg:w-64">
        <h1 className="mb-2 flex items-center gap-2 text-base font-semibold">
          <SettingsIcon size={18} className="text-brand-600" />
          {t('settings.title')}
        </h1>
        <nav className="flex flex-col">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                cn(
                  'rounded px-2 py-1.5 text-sm',
                  isActive
                    ? 'bg-brand-50 font-medium text-brand-700'
                    : 'text-slate-700 hover:bg-slate-50',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="min-w-0 flex-1">
        <Routes>
          <Route index element={<Navigate to="account" replace />} />
          <Route path="account" element={<MyAccountTab />} />
          {isAdmin ? <Route path="system" element={<SystemTab />} /> : null}
          {isAdmin ? <Route path="pricing" element={<PricingTab />} /> : null}
          {isAdmin ? <Route path="centers" element={<CentersTab />} /> : null}
          {isAdmin ? <Route path="rewards" element={<RewardsTab />} /> : null}
          {isAdmin ? <Route path="widget" element={<WidgetTab />} /> : null}
          {isAdmin ? <Route path="integrations" element={<IntegrationsTab />} /> : null}
          {isAdmin ? <Route path="users" element={<UsersTab />} /> : null}
          {isAdmin ? <Route path="roles" element={<RolesTab />} /> : null}
          {isAdmin ? <Route path="billing" element={<BillingTab />} /> : null}
          {isAdmin ? <Route path="subscription" element={<SubscriptionTab />} /> : null}
          {isAdmin ? <Route path="documents" element={<DocumentsTab />} /> : null}
          <Route path="*" element={<Navigate to="account" replace />} />
        </Routes>
      </div>
    </div>
  )
}
